import { sortAlphabetical } from "@/lib/js-helpers/sortAlphabetical";
import { Row } from "@tanstack/react-table";
import {
  StandingOfferTable,
  SubscriptionOfferTable,
  SubscriptionTable
} from "../types/subscriptions.type";

export function sortByPrice<
  T extends SubscriptionTable | SubscriptionOfferTable | StandingOfferTable
>(rowA: Row<T>, rowB: Row<T>): number {
  const aPrice: T["monthlyPriceUSD"] = rowA.getValue("monthlyPriceUSD");
  const bPrice: T["monthlyPriceUSD"] = rowB.getValue("monthlyPriceUSD");
  const aName: T["appName"] = rowA.getValue("appName");
  const bName: T["appName"] = rowB.getValue("appName");

  if (!aPrice && !bPrice) return sortAlphabetical(aName, bName);
  if (!aPrice) return -1;
  if (!bPrice) return 1;

  const aPriceFloat = parseFloat(aPrice);
  const bPriceFloat = parseFloat(bPrice);

  if (Number.isNaN(aPriceFloat) && Number.isNaN(bPriceFloat))
    return sortAlphabetical(aName, bName);
  if (Number.isNaN(aPriceFloat)) return -1;
  if (Number.isNaN(bPriceFloat)) return 1;

  if (aPriceFloat === bPriceFloat) return sortAlphabetical(aName, bName);

  return aPriceFloat - bPriceFloat;
}
